"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getNumberFromUnknown_1 = __importDefault(require("./getNumberFromUnknown"));
const getIntegerFromUnknown = (original) => {
    const numberFromOriginal = (0, getNumberFromUnknown_1.default)(original);
    if (!/^[0-9]+$/.test(`${numberFromOriginal}`)) {
        throw new Error('Unknown value is not an integer');
    }
    return numberFromOriginal;
};
exports.default = getIntegerFromUnknown;
